<template>
  <router-view v-if="disclaimer"
               :disclaimer="disclaimer"
               @update="fetchData">
  </router-view>
</template>
<script>
import disclaimerService from '../../services/disclaimerService';

export default {
  data() {
    return {
      disclaimer: null,
    }
  },
  computed: {
    disclaimerID() {
      return parseInt(this.$route.params.disclaimerID);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.disclaimer = await disclaimerService.getDisclaimer(this.disclaimerID)
      } catch (e) {
        this.$toast.error('Disclaimer not found.');
        await this.$router.replace({name: 'admin.disclaimers.index'});
      }
    }
  }
}
</script>
